import { EntityType } from 'src/constants/entity';

export const REF_TAG = {
  LEARNING_PATHWAY_SECTION_CTA_BTN: 'su_lp_cta',
  SEARCH_PAGE_CARD: 'su_search_card',
  WEBINAR_PAGE_CARD: 'su_webinar_card', // used for RegisterUserForWebinar API call input
  WEBINAR_CARD_JOIN: 'su_live_webinar_join_content_card',
  WEBINAR_CARD_REGISTER: 'su_live_webinar_registration_modal',
  WEBINAR_MODAL_JOIN: 'su_live_webinar_join_modal',
  TOPIC_BESSIE_BANNER: 'su_topic_ic_banner',
} as const;

export const getModuleCtaRefTag = (parentType?: EntityType): string => {
  switch (parentType) {
    case EntityType.LearningPathway:
      return 'su_lp_module_modal_cta';
    case EntityType.Topic:
      return 'su_tp_module_modal_cta';
    case EntityType.SearchPage:
      return 'su_sp_module_modal_cta';
    case EntityType.ModulePage:
      return 'su_module_page_cta';
    default:
      return 'su_generic_module_modal_cta';
  }
};

export const getModuleDownloadRefTag = (parentType?: EntityType): string => {
  switch (parentType) {
    case EntityType.LearningPathway:
      return 'su_lp_module_modal_download';
    case EntityType.Topic:
      return 'su_tp_module_modal_download';
    case EntityType.SearchPage:
      return 'su_sp_module_modal_download';
    case EntityType.ModulePage:
      return 'su_module_page_download';
    default:
      return 'su_generic_module_modal_download';
  }
};

/**
 * Generates the ref tag for the ungated campus navigation redirect to Seller Central.
 * Format: sc{countryCode}_su_edu_n
 * Returns undefined if countryCode is unavailable.
 */
export const getNavRefTag = (countryCode: string | undefined): string | undefined => (
  countryCode ? `sc${countryCode}_su_edu_n` : undefined
);
